module.exports = __webpack_public_path__ + "img/05.db85e4fd.jpg";